import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError("Please fill in all fields."); return; }
    setLoading(true);
    setError("");
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      navigate("/teacher");
    } else {
      setError(result.message || "Login failed.");
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.icon}>🎓</div>
        <h1 style={s.title}>Teacher Login</h1>
        <p style={s.sub}>Access your dashboard to upload notes & videos</p>


        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>Email address</label>
            <input
              style={s.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="teacher@school.com"
              autoComplete="email"
            />
          </div>
          <div style={s.field}>
            <label style={s.label}>Password</label>
            <div style={s.passRow}>
              <input
                style={{ ...s.input, flex: 1 }}
                type={showPass ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
              />
              <button type="button" style={s.eyeBtn} onClick={() => setShowPass((p) => !p)}>
                {showPass ? "🙈" : "👁"}
              </button>
            </div>
          </div>

          {error && <div style={s.error}>{error}</div>}

          <button type="submit" style={{ ...s.submitBtn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? "Signing in…" : "Sign In →"}
          </button>
        </form>

        <Link to="/" style={s.backLink}>← Back to home</Link>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" },
  card: { width: "100%", maxWidth: 420, background: "#1e293b", border: "1px solid #334155", borderRadius: 20, padding: "36px 32px", textAlign: "center" },
  icon: { fontSize: 40, marginBottom: 16 },
  title: { fontSize: 24, fontWeight: 700, color: "#f1f5f9", fontFamily: "'Sora',sans-serif", marginBottom: 8 },
  sub: { fontSize: 14, color: "#64748b", fontFamily: "'Sora',sans-serif", marginBottom: 24 },
  hint: { background: "#0f172a", border: "1px solid #334155", borderRadius: 10, padding: "12px 16px", fontSize: 13, color: "#94a3b8", fontFamily: "'Sora',sans-serif", textAlign: "left", marginBottom: 24, lineHeight: 1.8 },
  code: { background: "#1e293b", color: "#60a5fa", borderRadius: 4, padding: "1px 6px", fontFamily: "monospace", fontSize: 12 },
  form: { textAlign: "left", display: "flex", flexDirection: "column", gap: 16 },
  field: { display: "flex", flexDirection: "column", gap: 6 },
  label: { fontSize: 12, fontWeight: 600, color: "#94a3b8", fontFamily: "'Sora',sans-serif", textTransform: "uppercase", letterSpacing: "0.05em" },
  input: { background: "#0f172a", border: "1.5px solid #334155", borderRadius: 10, padding: "12px 14px", color: "#f1f5f9", fontSize: 14, fontFamily: "'Sora',sans-serif", outline: "none", width: "100%" },
  passRow: { display: "flex", gap: 8, alignItems: "center" },
  eyeBtn: { background: "#0f172a", border: "1.5px solid #334155", borderRadius: 10, padding: "11px 14px", cursor: "pointer", fontSize: 16, flexShrink: 0 },
  error: { background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)", borderRadius: 8, padding: "10px 14px", color: "#fca5a5", fontSize: 13, fontFamily: "'Sora',sans-serif" },
  submitBtn: { background: "#3b82f6", color: "#fff", border: "none", borderRadius: 10, padding: "14px", fontSize: 15, fontWeight: 600, cursor: "pointer", fontFamily: "'Sora',sans-serif", marginTop: 4 },
  backLink: { display: "block", marginTop: 24, fontSize: 13, color: "#475569", textDecoration: "none", fontFamily: "'Sora',sans-serif" },
};
